import allDashBoard from "./allDashboard";
import employee from "./dashboard";

import employeeType from "./employeeType";
// ==============================|| MENU ITEMS ||============================== //
const menuItems = {
  items: [allDashBoard, employee, employeeType],
};

export default menuItems;
